import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Pagination, Stack, Switch } from "@mui/material";
import { Addstocks } from "../addstocks";
import moment from "moment";
import { EditStock } from "../adminStocksEdit";
import { Loader } from "../loader";
import api from "../../../api";

// Import Lucide icons
import {
  Plus,
  Image,
  Video,
  FileText,
  Edit2,
  Trash2,
  Search,
  Filter,
  Calendar,
  User,
  Download,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { useAlert } from "react-alert";

export function PushNotification({ match }) {
  const alert = useAlert();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [selectedData, setSelectedData] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const getPosts = async () => {
    try {
      let payload = { page: page };
      setLoader(true);
      const postData = await api.getPushLogs(payload);
      console.log(postData);

      setData(postData.logs);
      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  return (
    <div className="crypto-trades-admin">
      {/* Header Section */}
      <div className="crypto-trades-header">
        <div className="content-of-header mb-0">
          <div className="title-section">
            <h1 className="crypto-trades-title">Mobile Push Notification</h1>
          </div>
          <button className="crypto-trades-add-btn" onClick={handleShow}>
            <Plus size={18} />
            Send Push Notification
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="dashboard-content">
        <div className="table-section">
          <div className="section-header">
            <h3 className="mb-0">All Push Notifications</h3>
            <div className="results-info">
              {data.length} {data.length === 1 ? "item" : "items"} found
            </div>
          </div>

          <Table
            data={data}
            setPage={setPage}
            page={page}
            noOfPost={noOfPost}
            limit={limit}
            handleShowEdit={handleShowEdit}
            handleShow={handleShow}
          />
        </div>
      </div>

      {/* Modals */}
      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        centered
        className="modern-modal"
      >
        <Modal.Body>
          <div className="modal-content-wrapper">
            <div className="modal-header">
              <h3>Send Push Notification</h3>
              <button className="modal-close-btn" onClick={handleClose}>
                ×
              </button>
            </div>
            <SendNotifyModal getPosts={getPosts} setShow={setShow} />
          </div>
        </Modal.Body>
      </Modal>

      {loader && <Loader />}
    </div>
  );
}

const Table = ({ data, page, setPage, noOfPost, limit, handleShow }) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    return moment(date).format("MMM D, YYYY • h:mm A");
  };

  if (data.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">📊</div>
        <h3>No Notification Found</h3>
        <p>Start sending notification</p>
        <button className="empty-action-btn" onClick={() => handleShow()}>
          <Plus size={16} />
          Add First Nofification
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="table-responsive-container">
        <table className="modern-table">
          <thead>
            <tr>
              <th>TITLE</th>
              <th>MESSAGE</th>
              <th>TYPE</th>
              <th>REDIRECT TO</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, key) => (
              <tr key={key}>
                <td className="date-cell">
                  <div className="date-info">
                    <span>{item?.title || "-"}</span>
                  </div>
                </td>
                <td className="date-cell">
                  <div className="date-info">
                    <span>{item?.message || "-"}</span>
                  </div>
                </td>
                <td className="date-cell">
                  <div className="date-info">
                    <span>{item?.type || "-"}</span>
                  </div>
                </td>
                <td className="date-cell">
                  <div className="date-info">
                    <span>{item?.redirectTo || "-"}</span>
                  </div>
                </td>
                <td className="date-cell">
                  <div className="date-info">
                    <Calendar size={14} />
                    <span>{formatDate(item?.createdAt)}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {data.length > 0 && (
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {Math.min((page - 1) * limit + 1, noOfPost)} to{" "}
            {Math.min(page * limit, noOfPost)} of {noOfPost} entries
          </div>
          <Stack spacing={2}>
            <Pagination
              count={Math.ceil(noOfPost / limit)}
              page={page}
              onChange={handleChange}
              shape="rounded"
              variant="outlined"
              size="medium"
              className="custom-pagination"
            />
          </Stack>
        </div>
      )}
    </>
  );
};

export function SendNotifyModal({ getPosts, setShow }) {
  const [loader, setLoader] = useState(false);
  const [selectedImg, setSelectedImg] = useState([]);
  const [inputData, setInputData] = useState({});

  const handleSubmit = async () => {
    try {
      if (!inputData.title) {
        alert("Please Insert Title.");
        return;
      }
      if (!inputData.message) {
        alert("Please Insert Message.");
        return;
      }
      if (!inputData.type) {
        alert("Please Select Type.");
        return;
      }
      if (!inputData.redirectTo) {
        alert("Please Select where to redirect user when press notification.");
        return;
      }
      setLoader(true);
      let payload = {
        title: inputData.title,
        message: inputData.message,
        type: inputData.type,
        redirectTo: inputData.redirectTo,
      };

      const signalResponse = await api.addPushLogs(payload);
      if (signalResponse?.success) {
        // alert("Stocks created successfully");
        setInputData({
          type: "",
        });
        setLoader(false);
        getPosts();
        setShow(false);
      } else {
        setLoader(false);
        alert("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong");
    }
  };

  return (
    <>
      <div className="add-stocks-container">
        <div className="add-stocks-card">
          <div className="card-body">
            <div className="form-group mb-3">
              <label className="form-label">Title</label>

              <input
                type="text"
                name="title"
                className="form-control"
                onChange={(e) =>
                  setInputData({
                    ...inputData,
                    title: e.target.value,
                  })
                }
                placeholder="Add Title"
              />
            </div>
            <div className="form-group mb-3">
              <label className="form-label">Message</label>
              <textarea
                name="message"
                value={inputData?.video}
                className="form-control video-input"
                onChange={(e) =>
                  setInputData({ ...inputData, message: e.target.value })
                }
                placeholder="Enter Message Here..."
                rows="3"
              ></textarea>
            </div>

            <div className="form-group mb-3">
              <label className="form-label">Type</label>

              <select
                name="type"
                onChange={(e) =>
                  setInputData({ ...inputData, type: e.target.value })
                }
                className="form-control"
              >
                <option value="">Select Type</option>
                <option value="paid">Paid</option>
                <option value="unpaid">Un-Paid</option>
              </select>
            </div>
            <div className="form-group mb-3">
              <label className="form-label">Redirect To</label>

              <select
                name="redirectTo"
                onChange={(e) =>
                  setInputData({ ...inputData, redirectTo: e.target.value })
                }
                className="form-control"
              >
                <option value="">Select Screen</option>
                <option value="Home">Home</option>
                <option value="Crypto">Crypto Updates</option>
                <option value="Stock">Stock Updates</option>
                <option value="Market">Market Updates</option>
                <option value="Education">Education Updates</option>
                <option value="Live">Live Session</option>
                <option value="Profile">Profile</option>
              </select>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="btn-secondary"
                onClick={() => setShow(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                className="btn-primary"
                disabled={loader}
              >
                {loader ? (
                  <>
                    <span className="spinner"></span>
                    Seding Push Notification...
                  </>
                ) : (
                  "Send Notification"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {loader && (
        <div className="loader-overlay">
          <div className="loader-container">
            <div className="loader-spinner">
              <div className="spinner-circle"></div>
              <div className="spinner-circle"></div>
              <div className="spinner-circle"></div>
            </div>
            <p className="loader-text">Sending push notification...</p>
          </div>
        </div>
      )}
    </>
  );
}
